import React, { Component } from 'react'
import { connect } from 'react-redux';
import { setFilter } from '../../actions/filters'
import getParams from '../utilities/getParams'
import moment from 'moment'
import DatePick from '../../components/datepick';
import DateRangePicker from './DateRangePicker';
import { fetchEndpointIfNeeded as ftch } from '../../actions/fetch';

// Actual class
class DateTimeFilter extends Component {
    constructor(props) {
        super(props)
        this.state = {
            input1: "",
            input2: "",
            startDate: new Date(),
            endDate: new Date()
        }
        this.handleDateChange = this.handleDateChange.bind(this)
        this.clearFilter = this.clearFilter.bind(this)
        this.handleFocus = this.handleFocus.bind(this)
        this.handleBlur = this.handleBlur.bind(this)

        this.mainInput = HTMLSelectElement

    }

    clearFilter() {
        this.setState({
            input1: '',
            input2: ''
        })
    }

    handleStatusFilterDropdown(event) {
        // let newInput = Number(event.target.value)
        let newInput = event.target.value.toString()

        this.setState({
            input1: newInput
        })
    }

    componentDidUpdate(prevProps, prevState) {
        
        if((prevState.input1 != this.state.input1) && ( prevState.input2 !=  this.state.input2)){
            this.bindToState()
        }
    }

    componentDidMount() {
       
    }

    handleDateChange(val){
        //  let newInput = event.target.value
        var val1 = moment(val[0]).format('YYYY-MM-DD 00:00:00');
        var val2 = moment(val[1]).format('YYYY-MM-DD 00:00:00');
        //  let startDate = event.target.value

        if(val1 !== 'Invalid date' && val2 !== 'Invalid date'){
            this.setState({
                input1:val1,
                input2: val2
            });
            // this.bindToState(val1,val2)
        }
        
        // this.props.dispatch(updateDateVal(e.target.value))
    }

    bindToState() {
        // [this.state.input1, this.state.input2]
        let filter = {}
        filter[this.props.filterName] = {
            type: "dateTime",
            value1: this.state.input1,
        }
        this.props.dispatch(setFilter(
            this.props.id,
            filter
        ))

    }

    handleFocus(e){
        if(e.target.type == "text"){
            e.target.type="date"
        }

    }

    handleBlur(e){
        // alert("now blur")
        let currentDate = moment().format("MM-DD-YYYY")
        let getDate = e.target.value
        let formatDate = getDate ? moment(getDate).format("MM-DD-YYYY") : "Search Date"

        e.target.type="text"
        e.target.value = formatDate

        
    }


    render() {
        // let i1 = this.props.value1
        return (
            <div className="form-group" style={{ width: '175px'}}>
                 <div style={{zIndex: "9"}} 
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Date Filter"
                >
                    <DatePick 
                        onChange={(e)=>this.handleDateChange(e)}
                        selected={this.state.input1}
                        placeholderText="Search filter"
                    />
                    {/* <DateRangePicker 
                        onChange={(e)=>this.handleDateChange(e)}
                    /> */}
                </div>
            </div>
        )
    }
}

export default connect(null, null, null, { withRef: true })(DateTimeFilter)


// WEBPACK FOOTER //
// ./src/components/filters/dateTimeFilter.js